<template>
  <div class="sso-callback">
    <div class="container">
      <div class="text-center">
        <div v-if="loading" class="loading-message">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
          <p class="mt-3">{{ $t('Processing SSO authentication...') }}</p>
        </div>
        <div v-else-if="error" class="error-message">
          <b-alert variant="danger" show>
            {{ error }}
          </b-alert>
          <b-button @click="redirectToLogin" variant="primary">
            {{ $t('Return to Login') }}
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from '../../../core/services/auth.service';
import ssoService from '../../../core/services/sso.service';
import {mapActions} from "vuex";

export default {
  name: "SsoCallback",
  data() {
    return {
      loading: true,
      error: null
    };
  },
  methods: {
    ...mapActions('global', ['updateLoginAlertMessage']),
    async processCallback() {
      try {
        const result = await ssoService.handleCallback();
        
        if (result.success && result.token) {
          // Save token
          auth.setToken(result.token);
          
          // Clean up URL
          const url = new URL(window.location.href);
          url.searchParams.delete('code');
          url.searchParams.delete('state');
          url.searchParams.delete('error');
          url.searchParams.delete('error_description');
          window.history.replaceState({}, document.title, url.pathname);
          
          // Redirect to dashboard
          this.$router.push('/');
        } else {
          // Show error
          this.error = result.error || this.$t('SSO authentication failed');
          this.updateLoginAlertMessage(this.error);
          // Redirect to login after a delay
          setTimeout(() => {
            this.$router.push('/login');
          }, 3000);
        }
      } catch (error) {
        this.error = error.message || this.$t('SSO authentication failed');
        this.updateLoginAlertMessage(this.error);
        setTimeout(() => {
          this.$router.push('/login');
        }, 3000);
      } finally {
        this.loading = false;
      }
    },
    redirectToLogin() {
      this.$router.push('/login');
    }
  },
  async mounted() {
    await this.processCallback();
  }
};
</script>

<style scoped>
.sso-callback {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.loading-message,
.error-message {
  padding: 2rem;
}

.error-message {
  max-width: 500px;
  margin: 0 auto;
}
</style>
